import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  Box,
  Card,
  Typography,
  Button,
  Chip,
} from "@mui/material";

import { keyframes } from "@mui/system";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

import axios from "api/baseurl";

import { useLocation, useNavigate } from "react-router-dom";
import PostConsultationModal from "./PostConsultationModal";
import RenderingPostConsultationModal from "./RenderingPCModal";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";import Pagination from "@mui/material/Pagination";
import CreateRenderingDoctorPrescription from "./CreateRenderingDoctorPrescription";

function RenderingPrescriptionPage() {
  const location = useLocation();
const navigate = useNavigate();
  const patientId = location.state?.patientId;

  const patientUserId = location.state?.patientUserId;

    const DoctorId = location.state?.DoctorId;


  const loginData = JSON.parse(
    localStorage.getItem("loginData")
  );

  const doctorUserId = loginData?.userid;

  const token = loginData?.token;

  const [loading, setLoading] = useState(true);

  const [records, setRecords] = useState([]);

  const [openModal, setOpenModal] = useState(false);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  // ================= FETCH RECORDS =================
    const [searchTerm, setSearchTerm] = useState("");

  const fetchClinicalRecords = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const secretKey = await fetchSecretKey();

      const response = await axios.get(
        `/api/patientregistration/patient/${patientId}/medications`,{
        params: { page: Math.max(0, pageNumber - 1) },    

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Clinical Records", response.data);
 if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setRecords(decryptedData.content || []);
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    //   if (Array.isArray(response.data)) {
    //     setRecords(response.data);
    //       setCurrentPage(decryptedData.number + 1);
    //       setTotalPages(decryptedData.totalPages);
    //   } else {
    //     setRecords([]);
    //   }
    } catch (error) {
      console.log("Fetch Error", error);

      setRecords([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (doctorUserId && patientId) {
      fetchClinicalRecords();
    } else {
      setLoading(false);
    }
  }, [doctorUserId, patientId]);

   const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };
useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchClinicalRecords(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  // ================= DECISION COLORS =================
 const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
      const payload = {};



const requestBody = encryptBody(payload, secretKey);

   
      const response = await axios.post(`/api/device/searchall`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },  
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        // setMappingList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching :", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
  searchData(currentPage);
}, [searchTerm, currentPage]);

  // Loader Animation
  
  const getDecisionColor = (decision) => {
    switch (decision) {
      case "RESOLVE":
        return {
          bg: "#E8F5E9",
          color: "#2E7D32",
        };

      case "ESCALATE":
        return {
          bg: "#FFF3E0",
          color: "#EF6C00",
        };

      case "EMERGENCY":
        return {
          bg: "#FFEBEE",
          color: "#C62828",
        };

      case "HOLD":
        return {
          bg: "#E3F2FD",
          color: "#1565C0",
        };

      default:
        return {
          bg: "#F5F5F5",
          color: "#424242",
        };
    }
  };

  // ================= TABLE STYLES =================

  const headerStyle = {
    padding: "16px",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "left",
    whiteSpace: "nowrap",
    border: "1px solid rgba(255,255,255,0.2)",
  };

  const bodyStyle = {
    padding: "16px",
    fontSize: "14px",
    color: "#333",
    verticalAlign: "top",
    border: "1px solid #E0E0E0",
  };

  // ================= LOADER =================

  const spinAnimation = keyframes`
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  `;

  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  // ================= LOADER UI =================

  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255,255,255,0.8)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            animation: `${spinAnimation} 1.5s linear infinite`,
          }}
        >
          {dotPositions.map((pos, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#2e7fae",
                position: "absolute",
                ...pos,
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          pb: 5,
        }}
      >
        {/* ================= HEADER ================= */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
            mt: 2,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
            <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 2,
  }}
>
  {/* BACK BUTTON */}
  <Button
    onClick={() => navigate(-1)}
              sx={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <ArrowBackIosNewIcon
                sx={{
                  fontSize: "18px",
                }}
              />
  </Button>
          <Box>
            <Typography
              sx={{
                fontSize: "22px",
                fontWeight: 700,
                color: "#1A237E",
              }}
            >
              Prescription Details
            </Typography>
</Box>
            {/* <Typography
              sx={{
                fontSize: "15px",
                color: "#666",
                mt: 0.5,
              }}
            >
              Clinical consultation records & follow-up management
            </Typography> */}
          </Box>

          <Button
            variant="contained"
            startIcon={<AddCircleRoundedIcon />}
            onClick={() => setOpenModal(true)}
            sx={{
              borderRadius: "14px",
              px: 3,
              py: 1.4,
              textTransform: "none",
              fontWeight: 700,
              fontSize: "12px",
              color: "#fff",
              background:
                "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",

              "&:hover": {
                color: "#fff",
                background:
                  "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
              },
            }}
          >
            Update Prescription
          </Button>
        </Box>

        {/* ================= TABLE ================= */}
<Typography
  sx={{
    fontSize: "20px",
    fontWeight: 800,
    color: "#111",
    mb: 2,
    ml: 1,
    letterSpacing: "0.3px",
  }}
>
  Patient Name : {records?.[0]?.patientName}
</Typography>
        <Card
          sx={{
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
          }}
        >
          <Box sx={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead
                style={{
                  background:
                    "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
                }}
              >
                <tr>
                 <th style={headerStyle}>Doctor Name</th>

                  <th style={headerStyle}>Medications</th>


                  <th style={headerStyle}>Duration</th>


                  <th style={headerStyle}>Time</th>

                 

                  <th style={headerStyle}>
                    prescribed Date
                  </th>
                  
                  <th style={headerStyle}>
                    Doctor Signature
                  </th>
                </tr>
              </thead>

              <tbody>
                {records?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        padding: "40px",
                        textAlign: "center",
                        fontSize: "22px",
                        fontWeight: 700,
                        color: "#9e9e9e",
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  records.map((item, index) => {
                    const decisionStyle =
                      getDecisionColor(item?.decision);

                    return (
                      <tr key={index}>
                        {/* Diagnosis */}
 <td style={bodyStyle}>
                          {item?.doctorName || "-"}
                        </td>
                       

                        {/* Medications */}

                        <td style={bodyStyle}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                           {item?.medication ? (
  <Chip
    label={item.medication}
    size="small"
    sx={{
      backgroundColor: "#EDE7F6",
      color: "#4527A0",
      fontWeight: 600,
    }}
  />
) : (
  <Typography>-</Typography>
)}
                          </Box>
                        </td>

                        {/* Instructions */}

                        <td style={bodyStyle}>
                          {item?.duration || "-"}
                        </td>

                        {/* Follow Up */}

                        <td style={bodyStyle}>
                          {item?.time || "-"}
                        </td>

                        {/* Decision */}

                       

                       

                        {/* Created Date */}

                        <td style={bodyStyle}>
                          {item?.prescribedDate
                            ? new Date(
                                item.prescribedDate
                              ).toLocaleString()
                            : "-"}
                        </td>
                       <td style={bodyStyle}>
  {item?.doctorSignature ? (
    <>
      <IconButton
        onClick={() => {
          window.open(item.doctorSignature, "_blank");
        }}
      >
        <VisibilityIcon />
      </IconButton>

      <div>
        <img
          src={item.doctorSignature}
          alt="Doctor Signature"
          style={{
            width: "120px",
            height: "60px",
            objectFit: "contain",
            border: "1px solid #ccc",
            marginTop: "8px",
            background: "#fff",
            padding: "4px",
          }}
        />
      </div>
    </>
  ) : (
    <span>No Signature</span>
  )}
</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
                
            </table>
            <Box mt={2} display="flex" justifyContent="center">
                                    <Pagination
                                      count={totalPages}
                                      page={currentPage}
                                      onChange={handlePageChange}
                                      color="success"
                                       sx={{
                              "& .MuiPaginationItem-root": {
                                borderRadius: "4px",
                                color: "#1A237E",          // Text color
                                borderColor: "#1A237E",    // Border color if outlined
                              },
                              "& .MuiPaginationItem-root.Mui-selected": {
                                backgroundColor: "#1A237E", // Selected background
                                color: "#fff",                 // Selected text color
                              },
                              "& .MuiPaginationItem-root:hover": {
                                backgroundColor: "#1A237E", // Slight hover effect
                              },
                            }}
                                    />
                                  </Box>
          </Box>
        </Card>

        {/* ================= MODAL ================= */}

        <CreateRenderingDoctorPrescription
  isOpen={openModal}
  onRequestClose={() => setOpenModal(false)}
  id={patientId}
  patientUserId={patientUserId}
  DoctorId={DoctorId}
  onAdded={fetchClinicalRecords}
/>
      </Box>
    </DashboardLayout>
  );
}

export default RenderingPrescriptionPage;